// extracted by mini-css-extract-plugin
export default {"stadic":"Tabs_stadic__H53vb","tabs":"Tabs_tabs__zD1QT","tab":"Tabs_tab__d+80N","tabIcon":"Tabs_tabIcon__VgDou","content":"Tabs_content__wwYBx","root":"Tabs_root__VUtUu"};